import { cn, getVersionForClone } from '@qr-front/ui/utils'
import { ROUTES } from 'constants/routesConstants'
import { GeneratorMobileHeaderContent } from 'features/generator/GeneratorLayout/GeneratorHeader/GeneratorMobileHeaderContent'

import { HeaderContainer } from '@/components/HeaderContainer'
import { LogoLink } from '@/components/LogoLink/LogoLink'

import { PrivateLayoutMobileSheet } from './PrivateLayoutMobileSheet'

export const PrivateLayoutMobileHeader = ({
	isEditMode,
	isChangeTypeMode,
	isDesktop,
	pathnameStartsWithTypeStep,
}: {
	isEditMode?: boolean
	isChangeTypeMode?: boolean
	isDesktop?: boolean
	pathnameStartsWithTypeStep?: boolean
}) => {
	const shouldRenderGeneratorHeader =
		!isDesktop &&
		(isEditMode || isChangeTypeMode || pathnameStartsWithTypeStep)

	return (
		<>
			<HeaderContainer className="shadow-[inset_0_-1px_0_0_theme('colors.border-grey-50')] desktop:hidden">
				<div className="mx-auto flex items-center justify-between desktop:max-w-[min(1216px,calc(100%-64px))]">
					<LogoLink href={ROUTES.cabinet.qrCodes} />
					<PrivateLayoutMobileSheet />
				</div>
			</HeaderContainer>
			{shouldRenderGeneratorHeader ? (
				<div className={cn(
                    "px-3 py-4 mobile:px-5 tablet:px-8 desktop:hidden",
                    getVersionForClone({
                        base: 'bg-generator-bg',
                        clone1: 'bg-[#FBFDFF]',
                    })
                )}>
					<GeneratorMobileHeaderContent
						isEditMode={!!isEditMode}
						isChangeTypeMode={!!isChangeTypeMode}
					/>
				</div>
			) : null}
		</>
	)
}
